import { Link } from "@tanstack/react-router";
import { ArrowRight, BookOpen, Route, Sparkles } from "lucide-react";
import { Badge, Button, Card, PageHeader } from "@/components/primitives";

export function HomePage() {
  return (
    <div className="page">
      <PageHeader
        eyebrow="Cosmos"
        title="Ask Cosmos anything about a course"
        subtitle="Search the AIHR catalog, ask course-specific questions, draft learning journeys, and route write actions through approvals."
      />
      <section className="hero-grid">
        <Card className="hero-card">
          <Sparkles size={28} />
          <h2>Course Q&A workspace</h2>
          <p>
            Ground answers in course metadata and retrieval context. Every answer
            includes citations and model-routing metadata.
          </p>
          <Link to="/workspace">
            <Button>
              Open workspace <ArrowRight size={16} />
            </Button>
          </Link>
        </Card>
        <Card>
          <BookOpen size={24} />
          <h3>Course catalog</h3>
          <p>Browse real Cosmos courses or the seed fallback for local demos.</p>
          <Link to="/courses">Explore courses</Link>
        </Card>
        <Card>
          <Route size={24} />
          <h3>Journey commands</h3>
          <p>Turn a prompt into a guarded journey assignment request.</p>
          <Link to="/journeys/new">Create a journey</Link>
        </Card>
      </section>
      <Card>
        <div className="inline-list">
          <Badge tone="success">Auth0 protected</Badge>
          <Badge tone="ai">MCP-ready</Badge>
          <Badge tone="warning">Writes require approval</Badge>
        </div>
      </Card>
    </div>
  );
}
